// Updated: localStorage remembers last used email on login
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import Logo from '../Logo';

const LS_EMAIL_KEY = 'shmc_admin_last_email';

const Login = () => {
  const [email, setEmail] = useState(() => localStorage.getItem(LS_EMAIL_KEY) || 'info@sisterhoodmemberclub.nl');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });

      if (error) throw error;

      if (data.user) {
        localStorage.setItem(LS_EMAIL_KEY, email);
        navigate('/kh-admin/dashboard');
      }
    } catch (error) {
      setError('Invalid login credentials');
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Login form */}
      <div className="w-full lg:w-1/2 flex flex-col bg-white">
        <div className="bg-[#5A130E] text-white py-20 px-8 md:px-16">
          <h2 className="text-3xl font-bold">Welkom terug!</h2>
          <p className="mt-2 text-white/80">Log in om door te gaan naar SHMC Admin</p>
        </div>
        <div className="flex-1 flex items-center justify-center px-8 md:px-16">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <div className="flex justify-center -mt-48 md:-mt-60 lg:-mt-70">
              <div className="w-32 h-32 rounded-full border-4 border-[#E37C64] flex items-center justify-center p-4 bg-white">
                <Logo className="w-full" />
              </div>
            </div>
          </div>
          
          <form className="mt-8 space-y-6" onSubmit={handleLogin}>
            {error && (
              <div className="text-red-500 text-center bg-red-50 p-2 rounded">{error}</div>
            )}
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">E-mailadres</label>
                <input
                  type="email"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#E37C64] focus:border-[#E37C64] sm:text-sm"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Wachtwoord</label>
                <input
                  type="password"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#E37C64] focus:border-[#E37C64] sm:text-sm"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#E37C64] hover:bg-[#5A130E] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E37C64]"
              >
                Inloggen
              </button>
            </div>
          </form>
          
          <div className="text-center">
            <a href="/" className="text-sm text-[#E37C64] hover:text-[#5A130E]">
              Terug naar website
            </a>
          </div>
        </div>
        </div>
      </div>
      
      {/* Right side - Image */}
      <div className="hidden lg:block lg:w-1/2 bg-[#5A130E]">
        <img
          src="/assets/login-image.webp"
          alt="Login background"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default Login;